import '../stylesheets/application.scss';

import Sittercity from './sittercity';
import App from '../apps/App.vue';
import { setupApollo } from '../lib/apollo_setup';

import router from '../router';
import store from '../store';

export const apolloProvider = setupApollo();

document.addEventListener('DOMContentLoaded', async () => {
  const appNode = document.getElementById('app-rerouted');

  if (appNode === null) {
    console.log('Continuing to entrypoints'); // eslint-disable-line no-console
  } else {
    appNode.innerHTML = '<div style="text-align: center; padding: 50px; font-size: 18px;">Loading...</div>';

    try {
      await store.dispatch('account/fetchAccountData');
    } catch (error) {
      console.error('Failed to fetch account data', error);
    }

    new Sittercity({
      router,
      store,
      apolloProvider,
      name: 'Sittercity',
      propsData: {
        skipSegmentPageEvent: true, // afterEach hook handles Segment in SPA mode (see router/index.ts)
      },
      render(createElement) {
        return createElement(App);
      },
    }).$mount('#app-rerouted');
  }
});
